module.exports = __webpack_public_path__ + "static/img/celero-logo.d976fbaf.png";